import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Async thunk to rate the order
export const rateOrder = createAsyncThunk(
  'order/rateOrder',
  async ({ orderId, rate, token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Customer/RateOrder', {
        orderId,
        rate,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,

        },
      }
      );
      return response.data; // Or return the rating value if necessary
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk to add feedback to the order
export const addFeedback = createAsyncThunk(
  'order/addFeedback',
  async ({ orderId, feedback ,token}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Customer/AddFeedBack', {
        orderId,
        feedBack: feedback,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,

        },
      }
      );
      return response.data; // Response from adding feedback
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    order: null,
    loading: false,
    error: null,
  },
  reducers: {
    setOrder: (state, action) => {
      state.order = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Rate Order
      .addCase(rateOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(rateOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.order = {
          ...state.order,
          Rate: action.payload.rate, // Update the order's rating
        };
      })
      .addCase(rateOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Feedback
      .addCase(addFeedback.pending, (state) => {
        state.loading = true;
      })
      .addCase(addFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.order = {
          ...state.order,
          feedback: action.payload.feedback, // Update feedback on the order
        };
      })
      .addCase(addFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setOrder } = orderSlice.actions;
export default orderSlice.reducer;
